import React from 'react';
import TableDataField from './TableDataField';

const LegacySalePriceField = ({ legacySalePrice }) => {
    return (
        <TableDataField extraStyling="col-small">
            {legacySalePrice}
        </TableDataField>
    );
};

export default LegacySalePriceField;
